import { useAuth0 } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loginRedirectOptions } from "../../utils/auth";
import { isAuthenticationError } from "../../utils/error";

export const AuthenticationErrorBoundary = ({ children }: { children: ReactNode }) => {
	const { loginWithRedirect } = useAuth0();

	return (
		<ErrorBoundary
			fallbackRender={() => null}
			onError={(error) => {
				// If this is an authentication error, close Sentry and redirect to login
				if (isAuthenticationError(error)) {
					Sentry.close(100);
					loginWithRedirect(loginRedirectOptions());
					return;
				}

				// If this a different error, re-throw it so it can be caught by the global error boundary
				throw error;
			}}
		>
			{children}
		</ErrorBoundary>
	);
};
